/**
 * Teacher seat — non-playing observer above the table.
 * Shows avatar (or camera when on), name, and "TEACHER" label.
 * Uses Convex game state and Agora AV context.
 */

import { StyleSheet, View } from 'react-native'
import { DS } from '../../../design-system'
import { color, fontFamily } from '../../../theme'
import { PlayerAvatar } from '../PlayerAvatar'
import { useGameState } from '../../../screens/GameContainer/useGameState'
import { useAVContext } from '../../../hooks/av'
import { userIdToAgoraUid } from '../../../hooks/av/uid'
import { useResponsive } from '@/screens/new-design/hooks'

export function TeacherSeat() {
  const { teacher, isTeacherSeated } = useGameState()
  const { state: avState } = useAVContext()
  const { verticalScale } = useResponsive()

  if (!teacher) return null

  const teacherAgoraUid = userIdToAgoraUid(teacher.userId)
  const remoteTeacher = avState.remoteUsers.find((u) => u.uid === teacherAgoraUid)
  const showVideo = isTeacherSeated
    ? avState.localCameraEnabled
    : !!remoteTeacher?.hasVideo

  const videoConfig = showVideo
    ? { playerId: isTeacherSeated ? 0 : teacherAgoraUid }
    : undefined

  return (
    <View style={styles.container}>
      <PlayerAvatar
        name={teacher.name}
        size={4}
        video={videoConfig}
        color="Shades/Maroon 2"
        invert
      />
      <DS.Text
        variant="Caption/Bold"
        style={[styles.name, { fontSize: verticalScale(10) }]}
        numberOfLines={1}
      >
        {teacher.name}
      </DS.Text>
      <DS.Text
        variant="Mini/Bold"
        style={[styles.observer, { fontSize: verticalScale(8) }]}
      >
        TEACHER
      </DS.Text>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  name: {
    color: color.palette.cream,
    fontFamily: fontFamily.GTAmericaExtendedMedium,
    textAlign: 'center',
    marginTop: 2
  },
  observer: {
    color: color.palette.lightGrey,
    fontFamily: fontFamily.GTAmericaExtendedMedium,
    textTransform: 'uppercase',
    textAlign: 'center'
  }
})
